import { clearEmptyErrors } from '@shared/lib/validation/clearEmptyErrorsValidation/clear-empty-errors';
import { EditFormKeys } from '../config/form-constants';
import { required } from '@shared/lib/validation/validateRequired/required';
import { validateForm } from '@shared/lib/validation/validate/validate';
import { EditFormFields } from '../ui/modal-edit-file/types';

export const validate = (fields: Partial<EditFormFields>) => {
    const { validateField, errors } = validateForm();
    validateField({
        name: EditFormKeys.Code,
        message: required(fields[EditFormKeys.Code]),
    });
    validateField({
        name: EditFormKeys.Name,
        message: required(fields[EditFormKeys.Name]),
    });
    validateField({
        name: EditFormKeys.Path,
        message: required(fields[EditFormKeys.Path]?.length),
    });
    validateField({
        name: EditFormKeys.Disk,
        message: required(fields[EditFormKeys.Disk]?.length),
    });
    validateField({
        name: EditFormKeys.UploadedFile,
        message: required(
            fields[EditFormKeys.UploadedFile]?.localFiles.length ||
                fields[EditFormKeys.UploadedFile]?.uploadedFiles.length
        ),
    });
    return clearEmptyErrors(errors);
};
